import { useTranslation } from 'react-i18next'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'

interface Props {
  size?: 'small' | 'medium'
}

/** Alterna o idioma da interface entre Português e Inglês — a escolha fica
 *  guardada em localStorage (ver detection.caches em shared/i18n/i18n.ts). */
export default function LanguageSwitcher({ size = 'small' }: Props) {
  const { i18n } = useTranslation()
  const current = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'pt'

  return (
    <ToggleButtonGroup
      value={current}
      exclusive
      size={size}
      onChange={(_, value) => value && i18n.changeLanguage(value)}
      aria-label="Idioma / Language"
    >
      <ToggleButton value="pt" aria-label="Português" sx={{ px: 1.25, fontSize: '0.75rem', fontWeight: 600 }}>
        PT
      </ToggleButton>
      <ToggleButton value="en" aria-label="English" sx={{ px: 1.25, fontSize: '0.75rem', fontWeight: 600 }}>
        EN
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
